import { gql } from "@urql/core";

const CreateUpdateProjectReusableFrag = gql`
  fragment projectAttrs on ProjectData {
    constructionTitle
    projectNumber
    description
    id
    unit {
      unit
      color
    }
    title
    status {
      status
      color
    }
    country
    lastEditBy {
      id
      fullName
      email
      lastName
      firstName
    }
  }
`;

const ModifyProjectMut = gql`
  mutation modifyProject($input: UpdateProjectInput!) {
    modifyProject(input: $input) {
      status
      message
    }
  }
`;

const ProjectUpdateMut = gql`
  mutation updateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      ...projectAttrs
    }
  }
  ${CreateUpdateProjectReusableFrag}
`;

const ProjectCreateMut = gql`
  mutation addProject($input: CreateProjectInput!) {
    addProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`;

const SameProjectCreateMut = gql`
  mutation addSameProject($input: CreateSameProjectInput!) {
    addSameProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      mandator
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`;

const ProjectStatusUpdateMut = gql`
  mutation modifyProject($input: UpdateProjectInput!) {
    modifyProject(input: $input) {
      status
      message
    }
  }
`;

const MultipleProjectsDeleteMut = gql`
  mutation removeProjects($input: RemoveProjectsInput!) {
    removeProjects(input: $input) {
      deletedIds
      undeletedIds
      errors
      __typename
    }
  }
`;

const DuplicateWizardInProjectMut = `
  mutation replicateWizard(
    $input:ReplicateWizardInput!
  ) {
    replicateWizard(
      input: $input
    ) {
      status
      message
    }
  }
`;

// Todo, implement mailingId when AB is ready
const DuplicateProjectMut = gql`
  mutation replicateProject($input: DuplicateProjectInput!) {
    replicateProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`;

const ShareProjectMut = gql`
  mutation shareProject($input: ShareProjectInput!) {
    shareProject(input: $input) {
      message
      status
    }
  }
`;

const CreateProjectReportsMut = gql`
  mutation createProjectReports($input: createProjectReportsArgs) {
    createProjectReports(input: $input) {
      bomCompact {
        id
        url
      }
      projectWithSpecText {
        id
        url
      }
    }
  }
`;

const CreateBOMUnmitigatedMut = gql`
  mutation createBOMUnmitigated($projectId: String!, $language: String!) {
    createBOMUnmitigated(projectId: $projectId, language: $language) {
      requestId
    }
  }
`;

const CreateTenderTextReportMut = gql`
  mutation createTenderText($wizardNodeId: String!, $language: String!) {
    createTenderText(wizardNodeId: $wizardNodeId, language: $language) {
      requestId
    }
  }
`;

const TroxnetUploadXmlMut = gql`
  mutation uploadTroxNetComWizard($input: UploadTroxNetComWizardInput!) {
    uploadTroxNetComWizard(input: $input) {
      status
      message
    }
  }
`;

const GenerateReportArchiveMut = gql`
  mutation generateReportArchive($input: GenerateReportArchiveInput!) {
    generateReportArchive(input: $input) {
      requestId
    }
  }
`;

export {
  ProjectCreateMut,
  SameProjectCreateMut,
  ProjectUpdateMut,
  ProjectStatusUpdateMut,
  MultipleProjectsDeleteMut,
  DuplicateProjectMut,
  CreateProjectReportsMut,
  CreateTenderTextReportMut,
  TroxnetUploadXmlMut,
  CreateBOMUnmitigatedMut,
  GenerateReportArchiveMut,
  ShareProjectMut,
  ModifyProjectMut,
  DuplicateWizardInProjectMut,
};
